import { CollectionType } from './types';

export const MAX_NAME_LENGTH = 64;
export const MAX_DESCRIPTION_LENGTH = 240;
export const MAX_TEXT_BLOCK_DESCRIPTION_LENGTH = 480;

export const TEXT_BLOCK = 'textBlock';

export const insightConstants = {
  LOAD_COLLECTIONS_ERROR: 'Unable to add insight. Please cancel and try again.',
  ADD_INSIGHT_TO_COLLECTIONS_ERROR: 'Adding insight has failed. Please try again.',
  SAVE_SUCCESS_MESSAGE: (insight: string, isTemplateAdmin: boolean): string =>
    `${insight} was successfully saved${!isTemplateAdmin ? ' in collections.' : '.'}`,
  ADD_INSIGHT_MODAL_TITLE: (isTemplateAdmin: boolean): string =>
    isTemplateAdmin ? 'Add insight' : 'Add to collection',
};

export const CollectionErrors = {
  LOAD_ERROR: 'Data has not been loaded, please try again later.',
  NOT_FOUND_ERROR: 'Collection is not available.',
};

export const TemplateInfo = {
  BANNER_MESSAGE: 'THIS IS A TEMPLATE.',
};

export const TemplateErrors = {
  NOT_FOUND_ERROR: 'Template is not available.',
};

export const getEmptyCollectionMessage = (type: CollectionType): string =>
  `This ${type} is currently empty, please go back and add an insight to it.`;

export const FILTER_CLIENT_KEY = 'FILTER_CLIENT_KEY';
